"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@bimser/core");
const __1 = require("..");
const pluginManager_1 = require("../pluginManager");
function default_1(key, state) {
    var _a, _b, _c, _d, _e, _f;
    const solutionExplorerData = state.plugins.get(__1.Plugins.SolutionExplorer.Constants.PluginId).data;
    const buildSettingType = !(0, core_1.isNullOrUndefined)(solutionExplorerData === null || solutionExplorerData === void 0 ? void 0 : solutionExplorerData.buildSetting.type);
    switch (key) {
        case pluginManager_1.DefaultToolbarItems.SAVEALL:
            return buildSettingType || !((_c = (_b = (_a = state === null || state === void 0 ? void 0 : state.layout) === null || _a === void 0 ? void 0 : _a.window) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.some(item => item.isModified));
        case pluginManager_1.DefaultToolbarItems.SAVE:
            return (buildSettingType ||
                !((_f = (_e = (_d = state === null || state === void 0 ? void 0 : state.layout) === null || _d === void 0 ? void 0 : _d.window) === null || _e === void 0 ? void 0 : _e.items) === null || _f === void 0 ? void 0 : _f.some(item => item.isModified && item.isActivityWindow && item.isVisible)));
    }
}
exports.default = default_1;
//# sourceMappingURL=isToolbarButtonDisabled.js.map